import { render, staticRenderFns } from "./ActionSection.vue?vue&type=template&id=6c2dc2a8&"
import script from "./ActionSection.vue?vue&type=script&lang=js&"
export * from "./ActionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports